import { superAxios } from '../../utils/axios';

export const SESSION_LOGIN = 'SESSION_LOGIN'; // TODO: to be deprecrate
export const SESSION_LOGIN_ADMIN = 'SESSION_LOGIN_ADMIN';
export const SESSION_LOGIN_SUPER = 'SESSION_LOGIN_SUPER';
export const SESSION_LOGIN_AS = 'SESSION_LOGIN_AS';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const SESSION_LOGOUT_AS = 'SESSION_LOGOUT_AS';
export const SESSION_RECOVER = 'SESSION_RECOVER';
export const SET_USER_STATE = 'SET_USER_STATE';
export const SET_ME = 'SET_ME';

// TODO: login to be deprecate
export const login = (email, token, role) => dispatch =>
  dispatch({
    type: SESSION_LOGIN,
    email,
    token,
    role
  });
export const loginAdmin = (email, token, role) => dispatch =>
  dispatch({
    type: SESSION_LOGIN_ADMIN,
    email,
    token,
    role
  });
export const loginSuper = (email, token, role) => dispatch =>
  dispatch({
    type: SESSION_LOGIN_SUPER,
    email,
    token,
    role
  });

export const loginAs = (token, companyId) => dispatch =>
  dispatch({
    type: SESSION_LOGIN_AS,
    token,
    companyId
  });
export const logout = () => dispatch =>
  dispatch({
    type: SESSION_LOGOUT
  });
export const logoutAs = () => dispatch =>
  dispatch({
    type: SESSION_LOGOUT_AS
  });
export const recover = () => dispatch =>
  dispatch({
    type: SESSION_RECOVER
  });
export const setUserState = values => dispatch =>
  dispatch({
    type: SET_USER_STATE,
    values: {
      ...values
    }
  });

export const setMe = data => dispatch =>
  dispatch({
    type: SET_ME,
    values: {
      ...data
    }
  });

/**
 * Obtiene la data de un superAdmin
 * @returns { email: string, id: number, roles: array, twoFactorAuthStatus: string }
 */
export const fetchMe = () => async dispatch => {
  try {
    const response = await superAxios.get(
      `${process.env.REACT_APP_API_URL}super/me`
    );
    dispatch(setMe(response.data.data));

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
